import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { ArrowRight } from "lucide-react";
import Footer from "../components/Footer";
import StickyNav from "../components/StickyNav";
import EspaceNumeriqueModal from "../components/cocon-sacre/EspaceNumeriqueModal";

// Import all Valouse components
import {
  ValouseHero,
  OpeningPhraseSection,
  PromiseSection,
  CircleSection,
  PlaceSection,
  CycleCoconSection,
  FormulasSection,
  ValouseFaqSection,
  ClosingPhraseSection,
  ValouseNewsletterSection,
  InteriorSection,
  InsideCoconSection,
  TestimonialsSection,
  ImmobileJourneySection,
  ChangeSection,
  EngagementSection,
} from "../components/valouse";

const Valouse = () => {
  const location = useLocation();
  const { setLanguage } = useLanguage();
  const [showEspaceModal, setShowEspaceModal] = useState(false);

  useEffect(() => {
    setLanguage('fr');
  }, [setLanguage]);

  useEffect(() => {
    document.title = "COCON Valouse 2026 | Retraite initiatique en Drôme Provençale – 20 places";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", "COCON VALOUSE : retraite spirituelle haut de gamme en Drôme Provençale. Cycle initiatique de transformation intérieure en petit groupe privé. Hameau privatisé, 20 places maximum. Reconnexion corps esprit.");
    }
  }, []);

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-[#E8D2B5]/50 text-[#3F2A24]">

      <StickyNav
        homeLabel="COCON"
        homePath="/valouse"
        triggerRatio={0.85}
        links={[
          { label: "La promesse", href: '#promesse' },
          { label: "L'expérience", href: '#interieur' },
          { label: 'Le lieu', href: '#lieu' },
          { label: 'Les coconeuses', href: '#cercle' },
          { label: 'Témoignages', href: '#temoignages' },
          { label: "Le cycle", href: '#cycle' },
          { label: 'Questions', href: '#faq' },
        ]}
      />

      {/* 1. HERO */}
      <ValouseHero />

      {/* PHRASE D'OUVERTURE */}
      <OpeningPhraseSection />

      {/* ESPACE NUMÉRIQUE — haut de page */}
      <section className="py-6 px-6 bg-[#E8D2B5]/50">
        <div className="flex justify-center">
          <button
            onClick={() => setShowEspaceModal(true)}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#C5A059] text-[#3F2A24] text-xs tracking-[0.18em] uppercase shadow-sm hover:bg-[#987f62] hover:text-[#F3E5CF] transition-colors min-h-[44px]"
            data-testid="espace-numerique-top-btn"
          >
            <span>J'accède à mon espace</span>
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </section>

      {/* 2. LA PROMESSE */}
      <PromiseSection />

      {/* 3. VOYAGE IMMOBILE — après La Promesse */}
      <ImmobileJourneySection />

      {/* 4. L'EXPÉRIENCE */}
      <InteriorSection />
      <InsideCoconSection />

      {/* 5. LE LIEU */}
      <PlaceSection />

      {/* 6. LE CERCLE DES COCONEUSES */}
      <CircleSection />

      {/* 7. TÉMOIGNAGES */}
      <TestimonialsSection />

      {/* 8. LA TRANSFORMATION — avant Les Formules */}
      <ChangeSection />

      {/* 9. LE PASSAGE — avant Les Formules */}
      <EngagementSection />

      {/* 10. LE CYCLE COCON — avant les formules */}
      <CycleCoconSection />

      {/* 11. LES FORMULES */}
      <FormulasSection />

      {/* 12. QUESTIONS FRÉQUENTES */}
      <ValouseFaqSection />

      {/* 13. CONCLUSION */}
      <ClosingPhraseSection />

      {/* ESPACE NUMÉRIQUE — bas de page */}
      <section className="py-10 px-6 bg-[#E8D2B5]/50">
        <div className="flex justify-center">
          <button
            onClick={() => setShowEspaceModal(true)}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#C5A059] text-[#3F2A24] text-xs tracking-[0.18em] uppercase shadow-sm hover:bg-[#987f62] hover:text-[#F3E5CF] transition-colors min-h-[44px]"
            data-testid="espace-numerique-bottom-btn"
          >
            <span>J'accède à mon espace</span>
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </section>

      {/* NEWSLETTER / INSTAGRAM */}
      <ValouseNewsletterSection />

      {/* FOOTER */}
      <Footer />

      {/* Espace Numérique Modal */}
      <EspaceNumeriqueModal
        isOpen={showEspaceModal}
        onClose={() => setShowEspaceModal(false)}
        language="fr"
        coconName="COCON VALOUSE"
        bgColor="#8d7a6b"
      />
    </div>
  );
};

export default Valouse;
